export default {
  id: 'profile',
  title: 'Profile',
  category: 'Employee',
  summary: 'Manage your avatar, contact information, signature, assigned charge codes, and late-entry reasons.',
  overview: 'Your profile stores personal settings used across Timeclerk, including the signature used when submitting timesheets and the charge codes available on your timesheet.',
  howItWorks: [
    'Contact details help administrators and integrations keep employee records current.',
    'Assigned charge codes determine which tasks appear on your timesheet. Auto-add can include newly assigned codes automatically.',
    'Your signature is captured for timesheet submission compliance.',
    'Late-entry reasons document why time was entered after a deadline when required.'
  ],
  actions: [
    {
      name: 'Update avatar',
      description: 'Uploads and crops a profile photo shown in the header.'
    },
    {
      name: 'Edit contact info',
      description: 'Updates address and phone information on your employee record.'
    },
    {
      name: 'Manage signature',
      description: 'Creates or replaces the signature used when submitting timesheets.'
    },
    {
      name: 'Manage late-entry reasons',
      description: 'Maintains the list of reasons you can select when entering time late.'
    },
    {
      name: 'Change password',
      description: 'Updates your login password (when available for your authentication method).'
    }
  ],
  tips: [
    'Keep your signature up to date before submitting timesheets that require it.',
    'If a charge code you need is missing, ask your administrator or use Add Task on the timesheet to request it.'
  ],
  related: ['timesheet', 'leave']
};



// WEBPACK FOOTER //
// ./client/help/content/profile.js